import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const useVerifySignUpEmail = (token?: string | null, newEmail?: boolean | null) => {
  return useQuery({
    queryKey: ['verify-sign-up-email', token],
    queryFn: async () => {
      const searchParams = new URLSearchParams();

      if (token) {
        searchParams.set('confirmation_token', token);
      }

      if (newEmail) {
        searchParams.set('new_email', String(newEmail));
      }

      const { data } = await axios.get(`provider_users/verify_email?${searchParams.toString()}`);
      return data;
    },
    retry: 0,
    enabled: !!token,
  });
};
